import React, { useContext } from 'react';
import { createPortal } from 'react-dom';

import { OnboardingFooterHostContext } from 'features/courier-onboarding/components/OnboardingFooterHostContext';

/**
 * Renders children into the sticky panel footer host.
 * Falls back to inline render if no host is available.
 */
const OnboardingPanelFooter: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const host = useContext(OnboardingFooterHostContext);
  if (!host) return <>{children}</>;
  return createPortal(children, host);
};

export default OnboardingPanelFooter;
